<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title">
        <template #afterTitle>
          <div class="d-flex align-items-center gap-2">
            <McButtonBack href="/report" :query="{ domain: domain }" />
            <ShareReport
              :report="report"
              :filter="baseFilter"
              :dropdownItems="itemDownloadDropdown"
              @doShare="downloadReport"
            />
            <DownloadReportDropdown :report="report" :items="itemDownloadDropdown" :actualTotal="actualTotal"/>
          </div>
        </template>
      </PageHeader>
    </div>
    <div class="d-flex align-items-center gap-2 me-2 absolute-right">
      <FavoriteReportButton
        v-if="hasAccess(['favorite-reports:update']) && !report.isSaved"
        :report="report"
      />
      <ModalSavedReport
        v-if="hasAccess(['saved-reports:read']) && !report.isSaved"
        :filter="filterValue"
        :detail="filterDetail"
        :report="report"
      />
      <McButton
        variant="secondary"
        :text="$t('report.title.reportParameter')"
        icon="icon-outline_filter"
        @click="showModal"
      />
    </div>
    <b-row style="margin-top: 80px">
      <b-col>
        <RitageSummary />
      </b-col>
      <b-col>
        <Graph />
      </b-col>
    </b-row>

    <AlertReportTooMany v-if="actualTotal > totalRows" />
    <McGrapqlTable
      v-if="Object.keys(filters).length > 0"
      :key="tableKey"
      bordered
      withCard
      searchable
      :fields="fields"
      :apiClient="apiClient"
      :hasCheckbox="false"
      :lazyLoadAddress="false"
      reportKey="summary-ritage-geofence"
      :isSelectable="false"
    >
      <template #viewManager="{ handleSetDataFields, dataColumns, initialFields }">
        <McFilterSelect
          :defaultColumnOrder="initialFields"
          :currentColumnOrder="dataColumns"
          @setColumn="handleSetDataFields"
          @setColumnReport="handleColumnReport"
        />
      </template>
      <template #additionalFilter>
        <b-col md="4" class="mc-row-check-wrapper">
          <McButton
            variant="secondary"
            :text="$t('report.title.duarationFilter')"
            icon="icon-outline_filter"
            @click="showModalDurationFilter"
          />
        </b-col>
      </template>
      <template #cell(hullNo)="data">
        {{ data.item.hullNo ?? '-' }}
      </template>
      <template #cell(driver)="data">
        {{ data.item.driver ?? '-' }}
      </template>
      <template #cell(startTime)="data">
        {{ data.item.startTimeRitage ? momentDatetimeShortMonth(data.item.startTimeRitage) : '-' }}
      </template>
      <template #cell(finishTime)="data">
        {{ data.item.endTimeRitage ? momentDatetimeShortMonth(data.item.endTimeRitage) : '-' }}
      </template>
      <template #cell(totalDuration)="data">
        {{ data.item.totalDurationRitage }}
      </template>
      <template #cell(totalHours)="data">
        {{ data.item.totalDurationMoving }}
      </template>
      <template #cell(totalHourStop)="data">
        {{ data.item.totalDurationStop }}
      </template>
      <template #cell(tripMileage)="data">
        {{ minimizeFloat(data.item.totalDistanceRitage) }}
      </template>
      <template #cell(startOdometer)="data">
        {{ minimizeFloat(data.item.startOdometer) }}
      </template>
      <template #cell(endOdometer)="data">
        {{ minimizeFloat(data.item.endOdometer) }}
      </template>
      <template #cell(passedSegment)="data">
        <HuggedValue
          :id="`passed-segment-${data.index}`"
          :value="data.item.passedSegments ? data.item.passedSegments.join(', ') : '-'"
        />
      </template>
      <template #cell(loadedDuration)="data">
        {{ data.item.totalDurationLoaded }}
      </template>
      <template #cell(unloadedDuration)="data">
        {{ data.item.totalDurationUnloaded }}
      </template>
    </McGrapqlTable>
    <ModalFilter
      v-if="isMounted"
      ref="modal-filter"
      :report="report"
      :unRedirect="true"
      @refresh-table="forceRerender"
    />
    <ModalFilter
      v-if="isMounted"
      ref="modal-duration-filter"
      :report="report"
      :unRedirect="true"
      @refresh-table="forceRerender"
      :parameter="'additionalFilter'"
      :title="$t('report.title.duarationFilter')"
      :isHaveResetButton="true"
    />
    <McReportDownloader />
    <ModalSavedReportVerification
      :key="modalVerifReport"
      :domain="domain"
      :message="message"
      :error="isError"
    />
    <ModalEmail
      v-if="actualTotal > totalRows"
      :id="idEmailModal"
      :recipients="recipientsEmail"
      @submit-emails="handleEmails"
    />
  </Layout>
</template>
<script>
import McButton from '@/components/McButton'
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header-v2'
import Layout from '@/router/layouts/main'
import McButtonBack from '@/components/McButtonBack'
import McGrapqlTable from '@/components/McGrapqlTable'
import McFilterSelect from '@/components/McFilterSelect'
import McReportDownloader from '@/components/McReportDownloader'
import { Helper } from '@/mixin/helper'
import moment from 'moment'
import fields from './lib/fields/fields'
import ModalFilter from '@/router/views/report/components/ModalFilter'
import reportList from '../../lib/reportList.js'
import { MixPanel } from '@/mixin/mixpanel'
import ModalSavedReport from '@/router/views/report/components/ModalSavedReport'
import { mapGetters } from 'vuex'
import { QueryCache } from '@/mixin/query-cache'
import responsive from '@/mixin/responsive'
import ModalSavedReportVerification from '@/router/views/report/components/ModalSavedReportVerification'
import FavoriteReportButton from '@/router/views/report/components/FavoriteReportButton'
import DownloadReportDropdown from '@/router/views/report/components/DownloadReportDropdown'
import ModalEmail from '@/router/views/report/components/ModalEmail'
import AlertReportTooMany from '@/router/views/report/components/AlertReportTooMany'
import ShareReport from '../../components/ShareReport.vue'
import RitageSummary from './summary.vue'
import Graph from './graph.vue'
import { EXPORT_SUMMARY_RITAGE_GEOFENCE } from '@/services/api/report/report'
import { EXPORT_SUMMARY_RITAGE_GEOFENCE_REPORT } from '../../../../../services/api/report/report'
import HuggedValue from '../../components/HuggedValue.vue'
moment.locale('id')

export default {
  page: {
    title: 'Report',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    McButtonBack,
    McGrapqlTable,
    McFilterSelect,
    McReportDownloader,
    McButton,
    ModalFilter,
    ModalSavedReport,
    ModalSavedReportVerification,
    FavoriteReportButton,
    DownloadReportDropdown,
    ModalEmail,
    AlertReportTooMany,
    ShareReport,
    RitageSummary,
    Graph,
    HuggedValue,
  },
  mixins: [Helper, MixPanel, responsive],
  data() {
    return {
      isMounted: false,
      excelIcon: require('@/assets/images/download-format/excel.png'),
      pdfIcon: require('@/assets/images/download-format/pdf.png'),
      totalRows: 1,
      filters: {},
      tableKey: 0,
      summary: {},
      isBusy: false,
      reportFields: fields.map((item, i) => ({ ...item, order: i + 1 })),
      reportKey: 'summary-ritage-geofence',
      filterDetail: {},
      summaryKey: 50,
      queryCache: new QueryCache(),
      message: '',
      isError: false,
      modalVerifReport: 100,
      emails: [],
      recipientsEmail: [],
      isSubmitEmail: false,
      idEmailModal: 'modal-email-summary-ritage-geofence',
      reportAfterEmail: '',
      actualTotal: 0,
      durationFilter: [],
    }
  },
  computed: {
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
      getFeatureFlagData: 'identity/getFeatureFlagData',
    }),
    domain() {
      return this.report.domain
    },
    title() {
      return this.report.labelName ?? this.$t(this.report.label)
    },
    fields() {
      return this.reportFields
    },
    columns() {
      const finalFields = []

      this.reportFields.forEach((field) => {
        if (Object.prototype.hasOwnProperty.call(field, 'children')) {
          finalFields.push(...field.children)
        } else {
          finalFields.push(field)
        }
      })
      return finalFields
        .filter((item) => item.shown || item.shown === undefined)
        .map((field) => field.header)
    },
    baseFilter() {
      const filter = this.getBaseFilter(this.filters)
      const result = {
        ...filter,
        column: this.columns,
      }
      return result
    },
    generateFilter() {
      const { valid, msg } = this.validateFilter(this.report.filter, this.filters)
      if (valid) {
        const model = this.baseFilter
        return { valid: true, model }
      } else {
        this.$mcToast.error(msg)
        return { valid: false, model: {} }
      }
    },
    filterReport() {
      const { valid, model } = this.generateFilter
      if (!valid) return null
      const filterBody = {
        ...model,
      }
      return filterBody
    },
    apiClient() {
      return {
        get: async (filter) => {
          const model = this.filterReport
          if (!model) return {}
          const self = this
          self.isBusy = true
          const res = await this.queryCache.fetch(
            EXPORT_SUMMARY_RITAGE_GEOFENCE,
            {
              filter: {
                ...model,
                ...filter,
              },
            },
            self.reportKey
          )
          if (res.summaryRitageGoefence.summaryRitageGeofences)
            res.summaryRitageGoefence.summaryRitageGeofences.data =
              res.summaryRitageGoefence.summaryRitageGeofences.data.map((item) => {
                return {
                  ...item,
                  durationFilter: this.durationFilter,
                }
              })
          const result = res.summaryRitageGoefence.summaryRitageGeofences
          self.totalRows = result?.pagination?.total ?? 0
          self.isBusy = false
          self.message = res.summaryRitageGoefence.message
          self.isError = !res.summaryRitageGoefence.isSuccessful
          self.modalVerifReport += 1
          self.actualTotal = result?.pagination?.actualTotal ?? 0
          self.$store.commit('report/setSummaryRitageReport', {
            summary: {
              isBusy: false,
              data: result ? { ...result.summary } : null,
            },
            chart: {
              isLoadingGraph: false,
              chartData: {
                labels: result?.histories.map((item) => self.momentDateShortMonth(item.date)) ?? [],
                datasets: [
                  {
                    label: self.$t('report.object.totalRitage'),
                    data: result?.histories.map((item) => item.totalRitage) ?? [],
                    fill: true,
                    spanGaps: false,
                    backgroundColor: '#0000ff80',
                    borderRadius: 50,
                    borderSkipped: 'bottom',
                  },
                ],
              },
            },
            list:
              result?.histories.map((item) => {
                return {
                  date: self.momentDateShortMonth(item.date),
                  totalRitage: item.totalRitage,
                }
              }) ?? [],
          })

          return result
        },
      }
    },
    savedReport() {
      return JSON.parse(localStorage.getItem('saveReports'))
    },
    report() {
      const reports = [...reportList].concat(this.savedReport)
      return reports.find((item) => item.key == this.reportKey)
    },
    filterValue() {
      return this.$store.state.report.filterValue
    },
    hasCsvScope() {
      return this.report.downloadOptions?.includes('csv') && this.hasAccess(['csv_report:read'])
    },
    itemDownloadDropdown() {
      let list = []
      if (
        this.getTotalDayReport(this.filters.periode) <= 7 ||
        this.hasOnlyOneVehicleReport(this.filters.vehicleId)
      ) {
        list = list.concat([
          {
            name: 'excel',
            label: this.$t('global.action.downloadExcel'),
            onClick: () => {
              this.downloadReport('xlsx')
            },
            icon: this.excelIcon,
          },
          {
            name: 'pdf',
            label: this.$t('global.action.downloadPdf'),
            onClick: () => {
              this.downloadReport('pdf')
            },
            icon: this.pdfIcon,
          },
        ])
      }
      if (this.hasCsvScope) {
        list.push({
          name: 'csv',
          label: this.$t('global.action.downloadCsv'),
          onClick: () => {
            this.downloadReport('csv')
          },
          icon: this.excelIcon,
        })
      }
      return list
    },
    hasEmail() {
      return this.emails && this.emails.length > 0
    },
  },
  mounted() {
    const emailStorage = localStorage.getItem('emailReceiverReport')
    if (emailStorage) {
      this.recipientsEmail = emailStorage.split(',')
    }

    this.reportKey =
      this.$route.query.key && this.savedReport.find((item) => item.key === this.$route.query.key)
        ? this.$route.query.key
        : this.reportKey
    const { reportFilter, reportFilterValue } = this.getFilterReport(this.reportKey)
    this.$store.commit('report/updateFilter', reportFilter)
    this.$store.commit('report/updateFilterValue', reportFilterValue)
    this.filters = { ...this.$store.state.report.filterReport }
    this.filterDetail = this.getReportDetail(this.reportKey) ?? {}
    this.isMounted = true
    this.track('View ' + this.report.event)
    if (!this.mediaQuery.matches) {
      this.$store.dispatch('layout/toggleMenu', true)
    }
  },
  methods: {
    getBaseFilter(filters) {
      if (!filters || Object.keys(filters).length <= 0) return {}
      const result = {}
      Object.keys(filters).forEach((item) => {
        if (
          filters[item] !== null &&
          ((Array.isArray(filters[item]) && filters[item].length > 0) ||
            (!Array.isArray(filters[item]) && filters[item]))
        ) {
          result[item] = filters[item]
        }
      })
      console.log(result)
      let {
        periode,
        loadingDuration,
        unloadingDuration,
        totalRitageDuration,
        loadedTravelDuration,
        unloadedTravelDuration,
        stoppedDurationLoaded,
        stoppedDurationUnloaded,
        ...otherFilter
      } = result

      const startDate =
        periode.length > 0 ? moment(periode[0] + ' 00:00:00.000').toISOString() : null
      const endDate = periode.length > 0 ? moment(periode[1] + ' 23:59:59.000').toISOString() : null
      const durationFilter = []
      if (loadingDuration && (loadingDuration.hours > 0 || loadingDuration.minutes > 0)) {
        durationFilter.push('loadingDuration')
        otherFilter = {
          ...otherFilter,
          loadingDuration: {
            limitDurationInMinutes: loadingDuration.hours * 60 + loadingDuration.minutes,
            limitType: loadingDuration.type,
          },
        }
      }
      if (unloadingDuration && (unloadingDuration.hours > 0 || unloadingDuration.minutes > 0)) {
        durationFilter.push('unloadingDuration')
        otherFilter = {
          ...otherFilter,
          unloadingDuration: {
            limitDurationInMinutes: unloadingDuration.hours * 60 + unloadingDuration.minutes,
            limitType: unloadingDuration.type,
          },
        }
      }
      if (
        totalRitageDuration &&
        (totalRitageDuration.hours > 0 || totalRitageDuration.minutes > 0)
      ) {
        durationFilter.push('totalRitageDuration')
        otherFilter = {
          ...otherFilter,
          totalRitageDuration: {
            limitDurationInMinutes: totalRitageDuration.hours * 60 + totalRitageDuration.minutes,
            limitType: totalRitageDuration.type,
          },
        }
      }
      if (
        loadedTravelDuration &&
        (loadedTravelDuration.hours > 0 || loadedTravelDuration.minutes > 0)
      ) {
        durationFilter.push('loadedTravelDuration')
        otherFilter = {
          ...otherFilter,
          travelLoadedDuration: {
            limitDurationInMinutes: loadedTravelDuration.hours * 60 + loadedTravelDuration.minutes,
            limitType: loadedTravelDuration.type,
          },
        }
      }
      if (
        unloadedTravelDuration &&
        (unloadedTravelDuration.hours > 0 || unloadedTravelDuration.minutes > 0)
      ) {
        durationFilter.push('unloadedTravelDuration')
        otherFilter = {
          ...otherFilter,
          travelUnloadedDuration: {
            limitDurationInMinutes:
              unloadedTravelDuration.hours * 60 + unloadedTravelDuration.minutes,
            limitType: unloadedTravelDuration.type,
          },
        }
      }
      if (
        stoppedDurationLoaded &&
        (stoppedDurationLoaded.hours > 0 || stoppedDurationLoaded.minutes > 0)
      ) {
        durationFilter.push('stoppedDurationLoaded')
        otherFilter = {
          ...otherFilter,
          stoppedLoadedDuration: {
            limitDurationInMinutes:
              stoppedDurationLoaded.hours * 60 + stoppedDurationLoaded.minutes,
            limitType: stoppedDurationLoaded.type,
          },
        }
      }
      if (
        stoppedDurationUnloaded &&
        (stoppedDurationUnloaded.hours > 0 || stoppedDurationUnloaded.minutes > 0)
      ) {
        durationFilter.push('stoppedDurationUnloaded')
        otherFilter = {
          ...otherFilter,
          stoppedUnloadedDuration: {
            limitDurationInMinutes:
              stoppedDurationUnloaded.hours * 60 + stoppedDurationUnloaded.minutes,
            limitType: stoppedDurationUnloaded.type,
          },
        }
      }
      const model = {
        startDate,
        endDate,
        ...otherFilter,
      }
      this.durationFilter = durationFilter
      return model
    },
    handleColumnReport(fields) {
      this.reportFields = fields
      this.tableKey += 1
      this.summaryKey += 1
    },
    formattingValue(value, unit) {
      if (!value) return null
      if (unit === 'duration') {
        const duration = value.split(':')
        return `${duration[0]} ${this.$t('global.time.hours')}, ${duration[1]} ${this.$t(
          'global.time.minutes'
        )}, ${duration[2]} ${this.$t('global.time.seconds')}`
      } else {
        return `${value} ${unit}`
      }
    },
    forceRerender() {
      this.filters = { ...this.$store.state.report.filterReport }
      this.filterDetail = this.getReportDetail(this.reportKey) ?? {}
      this.tableKey += 1
      this.summaryKey += 1
    },
    showModal() {
      this.$refs['modal-filter'].SetFormValues(this.filterValue)
      this.$bvModal.show(this.report.modal)
    },
    showModalDurationFilter() {
      this.$refs['modal-duration-filter'].SetFormValues(this.filterValue)
      this.$bvModal.show(this.report.modal + '-additional-filter')
    },
    handleEmails(emails) {
      this.emails = emails
      this.recipientsEmail = emails
      this.isSubmitEmail = true
      if (emails.length > 0) {
        localStorage.setItem('emailReceiverReport', emails.join())
      }
      this.$bvModal.hide(this.idEmailModal)
      this.$mcToast.info(this.$t('report.text.popupEmailInfo'))
      this.downloadReport(this.reportAfterEmail)
    },
    showDownloader(periode, extension, result) {
      const downloadProgress = {
        status: 'I',
        url: null,
        name:
          `${this.title} ` +
          moment(periode[0]).format('DD MMM YYYY') +
          ' - ' +
          moment(periode[1]).format('DD MMM YYYY') +
          `.${extension}`,
        periode:
          moment(periode[0]).format('DD MMM YYYY') +
          ' - ' +
          moment(periode[1]).format('DD MMM YYYY'),
        downloadedAt: moment().format('DD MMM YYYY HH:mm:ss'),
        type: extension,
        id: result.summaryRitageGeofenceReport.id,
      }
      if (result.isSuccessful) {
        this.$store.commit('report/doneProgress', downloadProgress)
      } else {
        downloadProgress.status = 'F'
        this.$store.commit('report/failProgress', downloadProgress)
      }
      this.$store.commit('report/showDownloadPopup', true)
    },
    cutText(text, limit) {
      if (text.length > limit) {
        return `${text.substring(0, limit)}...`
      } else {
        return text
      }
    },
    downloadReport(extension, contact) {
      if (
        !this.isSubmitEmail &&
        this.actualTotal > this.totalRows &&
        (!contact || contact.length <= 0)
      ) {
        this.$bvModal.show(this.idEmailModal)
        this.reportAfterEmail = extension
        return
      }
      this.isSubmitEmail = false

      const fileType = this.trackDownloadReport(this.report, extension, contact)

      const model = this.filterReport
      if (!model) {
        setTimeout(() => {
          this.showModal()
        }, 1000)
        return false
      }
      const { periode } = this.filters
      let filterVar = {
        ...model,
        subtitle: `Periode : ${this.momentDateLongMonth(periode[0])} - ${this.momentDateLongMonth(
          periode[1]
        )}`,
        downloadAs: fileType,
        emails: this.emails,
      }
      if (this.report.labelName) {
        filterVar.title = this.report.labelName
      }

      if (contact) {
        filterVar = {
          ...filterVar,
          isShared: true,
          contact: contact,
        }
      }
      this.$apollo
        .query({
          query: EXPORT_SUMMARY_RITAGE_GEOFENCE_REPORT,
          variables: {
            filter: filterVar,
          },
          fetchPolicy: 'no-cache',
        })
        .then((res) => {
          let isSuccessful = res.data.summaryRitageGeofenceReport.isSuccessful
          if (!this.hasEmail && !contact) {
            this.showDownloader(periode, extension, res.data.summaryRitageGeofenceReport)
          } else if (contact) {
            if (isSuccessful) this.$mcToast.success(this.$t('report.text.sharedSuccess'))
            else this.$mcToast.error(this.$t('report.text.sharedFailed'))
          }
        })
    },
  },
}
</script>
